/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-undef */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-confusing-arrow */
/* eslint-disable react/no-multi-comp */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-negated-condition */
import React from 'react';
import { useQuery } from '@apollo/client';
import { FSBTable } from 'components/common/FSBTable';
import Loader from 'components/common/Loader';
import { Button } from 'reactstrap';
import { MdOutlineExpandLess, MdOutlineExpandMore } from 'react-icons/md';
import ErrorMessage from 'components/ErrorMessage';
import NoDataFound from 'components/NoDataFound';
import { GET_SELLER_COMMISSION_HISTORY } from 'pages/Vendor/VendorGraphQL';
import {
  SellerCommissionHistoryColumns,
  childSellerCommissionHistoryColumns,
  subChildSellerCommissionHistoryColumns,
} from 'pages/Vendor/constants';
import { showSequenceNumber } from 'utils/constants';

const SubChildCommission = ({ row }) => {
  const { orderCommissionHistories } = row.original;
  return (
    <FSBTable
      keyField="id"
      columns={subChildSellerCommissionHistoryColumns}
      data={orderCommissionHistories || []}
      totalCount={orderCommissionHistories?.length}
      pagePerSize={orderCommissionHistories?.length}
      // SubComponent={LastRow}// May use later
      search={false}
      pagination={false}
      isRowExpanded
      getRowCanExpand={() => true}
      showPagination={false}
    />
  );
};

const ChildCommission = ({ row }) => {
  const findIndexOfItems = (item) => {
    return childSellerCommissionHistoryColumns.findIndex(
      (itm) => itm.accessorKey === item,
    );
  };
  childSellerCommissionHistoryColumns[findIndexOfItems('SNo')].cell = ({
    row,
    cell,
  }) => {
    return (
      <div className="d-flex">
        {row.getCanExpand() ? (
          <Button
            color="link"
            className="text-decoration-none p-0 text-active"
            type="button"
            {...{
              onClick: row.getToggleExpandedHandler(),
              style: { cursor: 'pointer' },
            }}
          >
            {row.getIsExpanded() ? (
              <MdOutlineExpandLess className="me-2" size={20} />
            ) : (
              <MdOutlineExpandMore className="me-2" size={20} />
            )}
          </Button>
        ) : null}
        {showSequenceNumber(cell, { pageSize: 0, pageNo: 0 })}
      </div>
    );
  };

  const { sellerCommissionHistories } = row.original;
  return (
    <FSBTable
      keyField="id"
      columns={childSellerCommissionHistoryColumns}
      data={sellerCommissionHistories || []}
      totalCount={sellerCommissionHistories?.length}
      pagePerSize={sellerCommissionHistories?.length}
      // SubComponent={LastRow}// May use later
      search={false}
      pagination={false}
      SubComponent={SubChildCommission}
      isRowExpanded={false}
      getRowCanExpand={() => true}
      showPagination={false}
    />
  );
};

const SellerCommissionTable = ({ filters }) => {
  const { data, loading, error } = useQuery(GET_SELLER_COMMISSION_HISTORY, {
    variables: {
      ...filters,
    },
    fetchPolicy: 'network-only',
  });

  const findIndexOfItem = (item) => {
    return SellerCommissionHistoryColumns.findIndex(
      (itm) => itm.accessorKey === item,
    );
  };

  SellerCommissionHistoryColumns[findIndexOfItem('SNo')].cell = ({
    row,
    cell,
  }) => {
    return (
      <div className="d-flex">
        {row.getCanExpand() ? (
          <Button
            color="link"
            className="text-decoration-none p-0 text-active"
            type="button"
            {...{
              onClick: row.getToggleExpandedHandler(),
              style: { cursor: 'pointer' },
            }}
          >
            {row.getIsExpanded() ? (
              <MdOutlineExpandLess className="me-2" size={20} />
            ) : (
              <MdOutlineExpandMore className="me-2" size={20} />
            )}
          </Button>
        ) : null}
        {showSequenceNumber(cell, { pageSize: 0, pageNo: 0 })}
      </div>
    );
  };

  if (loading) return <Loader />;
  if (error) {
    return <ErrorMessage error={error} />;
  }
  if (!data?.getSellerCommissionHistory?.length)
    return <NoDataFound message="Data not available" />;

  return (
    <>
      <FSBTable
        data={data?.getSellerCommissionHistory || []}
        columns={SellerCommissionHistoryColumns}
        totalCount={0}
        totalPages={0}
        // currentPageNo={filters.pageNo}
        // pageSize={filters.pageSize}
        keyField="id"
        showSearch={false}
        showFilters={false}
        showDelete={false}
        showPagination
        remote
        striped={false}
        hover={false}
        bordered={false}
        wrapperClass="table-responsive word-break"
        // handlePageChange={handlePageChange}
        // onSortChange={onSortChange}
        // sorting={sortBy}
        searchPlaceholder="Search Vendors"
        SubComponent={ChildCommission}
        // defaultSorting={defaultSorting}
        isRowExpanded={false}
        getRowCanExpand={() => true}
      />
    </>
  );
};
export default SellerCommissionTable;
